import axios from "axios";

export default () =>
   axios.create({
      baseURL: "",
      //withCredentials: true
   });


// WEBPACK FOOTER //
// ./src/api/api.js